import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';

class SimpleEditor extends Component {

    constructor(props) {
        super(props);
        this.state = {
            editMode: false
        };
    }

    componentDidMount() {
        this.resetState(this.props);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.initialValue !== this.props.initialValue) {
            this.resetState(this.props);
        }
    }

    resetState = (props) => {
        this.setState({
            name: this.prepareValueName(props.initialValue),
            extension: this.prepareValueExtension(props.initialValue),
        });
    }

    prepareValueName = (initialValue) => {
        let name = initialValue.split('.');
        name.pop();
        return name.join('.');
    }

    prepareValueExtension = (initialValue) => {
        let name = initialValue.split('.');
        const extension = name.pop();
        return '.' + extension;
    }

    onTextClick = (e) => {
        this.setState({ editMode: true });
    }

    onBlur = (value) => {
        this.setState({ editMode: false });
        this.props.onChangeValue(this.state.name + this.state.extension);
    }

    onChange = (evt) => {
        this.setState({ name: evt.target.value });
    }

    render() {
        if (this.state.editMode) {
            return (
                <div>
                    <Input
                        fullWidth
                        autoFocus
                        id="adornment-weight"
                        value={this.state.name}
                        onBlur={this.onBlur}
                        onChange={this.onChange}
                        endAdornment={<InputAdornment position="end">{this.state.extension}</InputAdornment>}
                    />
                </div>
            );
        } else {
            return (
                <div onClick={this.onTextClick} onBlur={this.onBlur} >
                    <b>{this.state.name}{this.state.extension}</b>
                </div>
            );

        }
    }
};

SimpleEditor.propTypes = {
    initialValue: PropTypes.string.isRequired,
    onChangeValue: PropTypes.func.isRequired
};

export default SimpleEditor;